module.exports = __webpack_public_path__ + "img/one_2.db9bad7a.png";